export const CART_DRAWER_OPEN_EVENT = "kuku:cart-drawer-open";

export function openCartDrawer() {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(new CustomEvent(CART_DRAWER_OPEN_EVENT));
}
